module.exports = __webpack_public_path__ + "static/media/google-logo.ed9bd53f.png";